<template>
  <div>
    <template v-if="type === 'mobile'">
      <template v-if="globalAds.length > 0">
        <div v-for="ad of globalAds" :key="ad.title" @click="openLink(ad)" ref="ads" class="adOuter slides pointer">
          <div class='adContainer w3-display-container eventItemImage' :class="ad.color" style="min-height:200px; width:100%;" :style="ad.images.mobile !== '' ? {'background-image': 'url(' + ad.images.mobile + ')'} : {}">
            <div v-if="ad.images.mobile === ''" class="w3-display-middle w3-block" style="padding:15px 12px 25px;">
              <h3>{{ad.title}}</h3>
              <p>{{ad.text}}</p>
              <button class="w3-button adButton" style="margin-top:5px;" :class="ad.buttonColor">{{ad.button}}</button>
            </div>
          </div>
        </div>
      </template>
    </template>

    <template v-if="type === 'sidebar'">
      <template v-if="globalAds.length > 0">
        <div v-for="ad of globalAds" :key="ad.title" @click="openLink(ad)" ref="ads" class="adOuter slides">
          <div class="pointer">
            <div class='adContainer w3-display-container eventItemImage' :class="ad.color" style="min-height:258px; width:100%;" :style="ad.images.sidebar !== '' ? {'background-image': 'url(' + ad.images.sidebar + ')'} : {}">
              <div v-if="ad.images.sidebar === ''" class="w3-display-middle w3-block" style="padding:15px">
                <h3>{{ad.title}}</h3>
                <p>{{ad.text}}</p>
                <button class="w3-button adButton w3-margin-top" :class="ad.buttonColor">{{ad.button}}</button>
              </div>
            </div>
          </div>
        </div>
        <div @click="openLink({url:'https://daytonalocal.com/advertisers'})" class="slides">
          <div class="pointer">
            <div class='adContainer w3-display-container eventItemImage adInfo' style="min-height:258px; width:100%; color:#fafafa;">
              <div class="w3-display-middle w3-block" style="padding:15px">
                <h3>Advertise Here!</h3>
                <p>Reach local users interested in your products / services</p>
                <button class="w3-button adButton w3-margin-top w3-green">View Pricing</button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </template>

    <template v-if="type === 'inline'">
      <template v-if="width > 600">
        <div v-if="nextAd" class="pointer eventItemImage" style="height:115px" :class="nextAd.color" @click="openLink(nextAd)" :style="nextAd.images.inline !== '' ? {'background-image': 'url(' + nextAd.images.inline + ')'} : {}">
          <div class="w3-row w3-display-container" v-if="nextAd.images.inline === ''">
            <div class="w3-col s10" style="padding-top:18px; padding-left:10px;">
              <h3 class="title">{{nextAd.title}}</h3>
              <p style="padding-left:10px; margin:0">{{nextAd.text}}</p>
            </div>
            <button class="w3-button adButton w3-display-right w3-margin-right" :class="nextAd.buttonColor">{{nextAd.button}}</button>
          </div>
        </div>
        <div v-else>
          <div class="w3-row w3-display-container">
            <div class="w3-col s10" style="padding-top:18px; padding-left:10px;">
              <h3 class="title">Advertise Here</h3>
              <p style="padding-left:10px; margin:0">Low monthly rates and daily event page pricing. Targeted local advertising like no other!</p>
            </div>
            <button class="w3-button adButton w3-display-right w3-margin-right w3-green">Get Started Now</button>
          </div>
        </div>
      </template>
      <template v-if="width < 601">
        <div v-if="nextAd" class="w3-display-container pointer eventItemImage" style="height:200px; width:100%;" :class="nextAd.color" @click="openLink(nextAd)" :style="nextAd.images.mobile !== '' ? {'background-image': 'url(' + nextAd.images.mobile + ')'} : {}">
          <div v-if="nextAd.images.mobile === ''" class="w3-display-middle w3-block w3-center" style="padding:15px 12px 25px;">
              <h3>{{nextAd.title}}</h3>
              <p>{{nextAd.text}}</p>
            <button class="w3-button adButton" style="margin-top:5px;" :class="nextAd.buttonColor">{{nextAd.button}}</button>
          </div>
        </div>
      </template>
    </template>
    
    <template v-if="globalAds.length && type === 'attraction-page' || type === 'restaurant-page'">
      <div v-for="ad of globalAds" :key="ad.title" @click="openLink(ad)" ref="ads" class="adOuter slides">
        <template v-if="width > 600">
          <div v-if="ad" class='pointer w3-display-container eventItemImage' :class="ad.color" style="height:115px;" @click="openLink(ad)" :style="ad.images.inline !== '' ? {'background-image': 'url(' + ad.images.inline + ')'} : {}">
            <!-- <div class="sponsoredBy w3-display-topright">SPONSORED BY</div> -->
            <div class="w3-col m10" style="padding-top:18px; padding-left:10px;" v-if="ad.images.inline === ''">
              <h3 class="title">{{ad.title}}</h3>
              <p style="padding-left:10px; margin:0">{{ad.text}}</p>
            </div>
            <button v-if="ad.images.inline === ''" class="w3-button adButton w3-display-right w3-margin-right" :class="ad.buttonColor">{{ad.button}}</button>
          </div>
        </template>
        <template v-if="width < 601">
          <div class='adContainer w3-display-container eventItemImage' :class="ad.color" style="min-height:200px; width:100%;" :style="ad.images.mobile !== '' ? {'background-image': 'url(' + ad.images.mobile + ')'} : {}">
            <div v-if="ad.images.mobile === ''" class="w3-display-middle w3-block" style="padding:15px 12px 25px;">
              <h3>{{ad.title}}</h3>
              <p>{{ad.text}}</p>
              <button class="w3-button adButton" style="margin-top:5px;" :class="ad.buttonColor">{{ad.button}}</button>
            </div>
          </div>
        </template>
      </div>
    </template>
    
    <template v-if="globalAds.length && type === 'event-page'">
      <template v-if="!showCustomAd">
        <div v-for="ad of eventAds" :key="ad.title" @click="openLink(ad)" ref="ads" class="adOuter slides">
          <template v-if="width > 600">
            <div v-if="ad" class='pointer w3-display-container eventItemImage' :class="ad.color" style="height:115px;" @click="openLink(ad)" :style="ad.images.inline !== '' ? {'background-image': 'url(' + ad.images.inline + ')'} : {}">
              <div class="w3-col m10" style="padding-top:18px; padding-left:10px;" v-if="ad.images.inline === ''">
                <div class="sponsoredBy w3-display-topright">SPONSORED BY</div>
                <h3 class="title">{{ad.title}}</h3>
                <p style="padding-left:10px; margin:0">{{ad.text}}</p>
              </div>
              <button v-if="ad.images.inline === ''" class="w3-button adButton w3-display-right w3-margin-right" :class="ad.buttonColor">{{ad.button}}</button>
            </div>
          </template>
          <template v-if="width < 601">
            <div class='adContainer w3-display-container eventItemImage' :class="ad.color" style="min-height:200px; width:100%;" :style="ad.images.mobile !== '' ? {'background-image': 'url(' + ad.images.mobile + ')'} : {}">
              <div class="sponsoredBy w3-display-topright">SPONSORED BY</div>
              <div v-if="ad.images.mobile === ''" class="w3-display-middle w3-block" style="padding:15px 12px 25px;">
                <h3>{{ad.title}}</h3>
                <p>{{ad.text}}</p>
                <button class="w3-button adButton" style="margin-top:5px;" :class="ad.buttonColor">{{ad.button}}</button>
              </div>
            </div>
          </template>
        </div>
      </template>
      <template v-if="showCustomAd">
        <div ref="ads" class="adOuter">
          <template v-if="width > 600">
            <div v-if="selectedAd" class='pointer w3-display-container eventItemImage' :class="selectedAd.color" style="height:115px;" :style="selectedAd.images.inline !== '' ? {'background-image': 'url(' + selectedAd.images.inline + ')'} : {}">
              <div class="w3-col s10" style="padding-top:18px; padding-left:10px;" v-if="selectedAd.images.inline === ''">
                <div class="sponsoredBy w3-display-topright">SPONSORED BY</div>
                <h3 class="title">{{selectedAd.title}}</h3>
                <p style="padding-left:10px; margin:0">{{selectedAd.text}}</p>
              </div>
              <button v-if="selectedAd.images.inline === ''" class="w3-button adButton w3-display-right w3-margin-right" :class="selectedAd.buttonColor">{{selectedAd.button}}</button>
            </div>
          </template>
          <template v-if="width < 601">
            <div class='adContainer w3-display-container eventItemImage' :class="selectedAd.color" style="min-height:200px; width:100%; animation: none;" :style="selectedAd.images.mobile !== '' ? {'background-image': 'url(' + selectedAd.images.mobile + ')'} : {}">
              <div v-if="selectedAd.images.mobile === ''" class="w3-display-middle w3-block" style="padding:15px 12px 25px;">
                <h3>{{selectedAd.title}}</h3>
                <p>{{selectedAd.text}}</p>
                <button class="w3-button adButton" style="margin-top:5px;" :class="selectedAd.buttonColor">{{selectedAd.button}}</button>
              </div>
            </div>
          </template>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ads',
  props: ['type','eventid','showCustomAd'],
  data() {
    return {
      slideIndex: 0,
      width: window.innerWidth
    }
  },
  computed: {
    nextAd() {
      for (let ad of this.globalAds) {
        if (!ad.shown) {
          ad.shown = true
          return ad
        }
      }
    },
    eventAds() {
      let obtainedAds = this.globalAds.filter((ad) => {
        if (ad.eventid === this.eventid) {
          return ad
        }
      })
      for (let i = obtainedAds.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [obtainedAds[i], obtainedAds[j]] = [obtainedAds[j], obtainedAds[i]];
      }
      return obtainedAds
    },
    ...mapState([
      'user',
      'globalAds',
      'selectedAd'
    ])
  },
  created() {
    this.$store.dispatch('getActiveAds').then(() => {
      this.showSlides()
    })
    window.onresize = () => {
      this.width = window.innerWidth
    }
  },
  methods: {
    showSlides() {
      if (this.$refs['ads']) {
        let sponsorSlides = this.$refs['ads']
        if (sponsorSlides.length > 0) {
          for (let slide of sponsorSlides) {
            slide.classList.remove('activeSlide');
          }
          this.slideIndex++;
          if (this.slideIndex > sponsorSlides.length) {this.slideIndex = 1}
          sponsorSlides[this.slideIndex-1].classList.add('activeSlide');
          setTimeout(this.showSlides, 6000);
        }
      }
    },
    openLink(ad) {
      if (ad.url) {
        if (!/^(f|ht)tps?:\/\//i.test(ad.url)) {
          window.open('//' + ad.url, '_blank');
        } else {
          window.open(ad.url, '_blank')
        }
        
        if (this.user) {
          if (this.user.uid === ad.uid) {
            console.log('logged in advertiser does not count click')
            return
          }
        }
        let clickData = {
          adID: ad.id,
          created: new Date().toISOString()
        }
        this.$store.dispatch('addClick', clickData)
      } else {
        console.log('no link')
      }
    }
  },
}
</script>

<style scoped>
@media screen and (min-width: 768px) {
  .title {padding:4px 10px 0; margin-bottom:4px}
}
.adOuter {margin:0 4px 8px; overflow:hidden;}
.sponsoredBy {font-size:7pt; background:rgba(250,250,250,0.4); color:#000; padding:5px 5px 2px;}

.eventItemImage {cursor:pointer; overflow:hidden; background-size:cover; background-position:center; background-repeat:no-repeat;}
</style>
